import React from 'react'
import PropTypes from 'prop-types'

import { getCurrentLanguage } from 'translation'

const AlarmModalDays = ({ activeDays, isSelectable, selectDayHandler }) => {
  const days = {
    en: ['s', 'm', 't', 'w', 't', 'f', 's'],
    fr: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
  }

  const localizedDays = days[getCurrentLanguage()]

  return (
    <div className="alarm_mode_w_list">
      <ul className="alarm_modal_days">
        {localizedDays.map((day, index) => (
          <li key={days.en[index] + days.fr[index]} className="alarm_modal_days_item">
            {isSelectable ? (
              <button
                className={`alarm_modal_days_day_btn ${
                  activeDays[index] ? 'active_state' : ''
                }`}
                onClick={(e) => (e.stopPropagation(), selectDayHandler(index))}
              >
                {day}
              </button>
            ) : (
              <div
                className={`alarm_modal_days_day ${
                  activeDays[index] ? 'active_state' : ''
                }`}
              >
                {day}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default AlarmModalDays

AlarmModalDays.propTypes = {
  activeDays: PropTypes.array.isRequired,
  selectDayHandler: PropTypes.func,
  isSelectable: PropTypes.bool,
}

AlarmModalDays.defaultProps = {
  selectDayHandler: () => {},
  isSelectable: false,
}
